import { useQuery, useLazyQuery, gql } from "@apollo/client"

const REPORTLOCATIONSTRAINING_FIELDS = `
  id
  name
  timeZone
  complete
  inProgress
  overdue
  none
  percentComplete
  percentInProgress
  percentOverdue
  userCount
`

const REPORTLOCATIONSTRAINING_QUERY = gql`
  query ReportLocationsTraining($locations: [ID!]!, $groups: [ID!]) {
    reportLocationsTraining(locations: $locations, groups: $groups)
    {
      ${REPORTLOCATIONSTRAINING_FIELDS}
    } 
  }
`

const useQueryReportLocationsTraining = (options) =>
  useQuery(REPORTLOCATIONSTRAINING_QUERY, {
    fetchPolicy: "cache-and-network",
    ...options,
  })

const useLazyQueryReportLocationsTraining = (options) =>
  useLazyQuery(REPORTLOCATIONSTRAINING_QUERY, {
    fetchPolicy: "cache-and-network",
    ...options,
  })

export { useQueryReportLocationsTraining, useLazyQueryReportLocationsTraining }
